import { Component, OnInit, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { catchError, of } from 'rxjs';
import { AnimatedCounterDirective } from '../../directives/animated-counter.directive';
import { DashboardService } from 'app/services/dashboard/dashboard.service';
import { Router } from '@angular/router';
import { ImageUrlPipe } from '../../pipe/image-url.pipe';

interface StatCard {
  title: string;
  value: number;
  icon: string;
  color: string;
  change: number;
  route: string;
}


@Component({
  selector: 'app-dashboard-stats',
  standalone: true,
  imports: [CommonModule, AnimatedCounterDirective,ImageUrlPipe],
  templateUrl: './dashboard-stats.component.html',
  styleUrl: './dashboard-stats.component.scss'
})
export class DashboardStatsComponent implements OnInit {
  private dashboardService = inject(DashboardService);
  logo : string ="assets/logo/logo.png"
  stats = signal<StatCard[]>([]);
  isLoading = signal(true);
  lastUpdated = signal<Date | null>(null);

  readonly cards: Omit<StatCard, 'value'>[] =[
  {
    title: 'Products',
    icon: '📦',
    color: '#6366f1',
    change: 0,
    route: '/admin/products'
  },

  {
    title: 'Categories',
    icon: '🏷️',
    color: '#22c55e',
    change: 0,
    route: '/admin/categories'
  },

  {
    title: 'Orders',
    icon: '🛒',
    color: '#f59e0b',
    change: 0,
    route: '/admin/orders'
  },

  {
    title: 'Brands',
    icon: '🏢',
    color: '#ec4899',
    change: 0,
    route: '/admin/brands'
  },
  ]
 
constructor(private router: Router) {}

  navigateTo(route: string): void {
    if (route) {
      this.router.navigate([route]);
    }
  }
  ngOnInit(): void {
    this.loadStats();
    // Auto-refresh every 5 minutes
    setInterval(() => this.loadStats(), 300000);
  }

  loadStats(): void {
    this.isLoading.set(true);
    this.dashboardService.getDashboardStats().pipe(
      catchError(err => {
        console.error('Failed to load stats:', err);
        // Fallback mock data
        return of({
          products: 1247,
          categories: 89,
          orders: 3456,
          brands: 156
        });
      })
    ).subscribe(data => {
      this.stats.set(this.cards.map((card, index) => ({
        ...card,
        value: [data.products, data.categories, data.orders, data.brands][index]
      })));
      this.lastUpdated.set(new Date());
      this.isLoading.set(false);
    });
  }
getAbs(value: number): number {
  return Math.abs(value);
}
  trackByFn(index: number): number {
    return index;
  }
}